var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 8,
    viewBox: "0 0 4 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M3.89382 3.71448L0.626836 0.118098C0.483483 -0.0393636 0.251228 -0.0393635 0.107513 0.118098C-0.0358402 0.275558 -0.0358402 0.531316 0.107513 0.688776L3.11536 3.9998L0.107876 7.31083C-0.0354772 7.46829 -0.0354772 7.72405 0.107876 7.8819C0.251229 8.03937 0.483846 8.03937 0.627199 7.8819L3.89418 4.28556C4.03533 4.12972 4.03533 3.86995 3.89382 3.71448Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrRight);
export default __webpack_public_path__ + "static/media/arr-right.904e22f1a7186c2e112f5e8fc43d6e5d.svg";
export { ForwardRef as ReactComponent };